import React from 'react'
import {connect} from 'react-redux'

import Spinner from 'react-spinkit'

import {
  SESSION_REQUEST_STATUSES
} from './config/constants'

import {
  watchImmediateSessionRequest,
  unwatchImmediateSessionRequest
} from './data/watchers/immediate_session_request'

import timeoutSessionRequest from './data/setters/timeout_session_request'

class SessionBookConfirmationImmediate extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onSessionRequestTimeout = this.onSessionRequestTimeout.bind(this)
  }

  componentWillMount () {
    this.props.onLoadComponent(
      this.props.expert.get('uid'),
      this.props.currentUser.get('uid')
    )
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.sessionRequest && nextProps.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.ACCEPTED && nextProps.sessionRequest.get('sessionId')) {
      const sessionId = nextProps.sessionRequest.get('sessionId')
      const requestData = this.props.sessionRequest.merge({type: 'immediate'})

      this.props.onSessionRequestAccepted({sessionId, requestData})
    }

    if (this.props.sessionRequest !== nextProps.sessionRequest &&
        (nextProps.sessionRequest && nextProps.sessionRequest.get('status') === SESSION_REQUEST_STATUSES.REQUESTED)) {
      this.startSessionRequestTimeout()
    }
  }

  componentWillUnMount () {
    this.props.onUnloadComponent(
      this.props.expert.get('uid'),
      this.props.currentUser.get('uid')
    )
  }

  startSessionRequestTimeout () {
    if (this.sessionRequestTimeoutId) return

    this.sessionRequestTimeoutId = setTimeout(this.onSessionRequestTimeout, this.props.sessionRequestTimeout * 1000)
  }

  onSessionRequestTimeout () {
    this.props.onSessionRequestTimeout(this.props.sessionRequest)
  }

  renderInnerContent () {
    if (!this.props.sessionRequest) return false

    const status = this.props.sessionRequest.get('status')
    const sessionRef = this.props.sessionRequest.get('sessionId')

    if (sessionRef) {
      return (
        <div>
          <div className='section' style={{maxWidth: '400px'}}>
            <p>
              Expert is accepted your session request.
            </p>
          </div>
        </div>
      )
    }
    else if (status === SESSION_REQUEST_STATUSES.REQUESTED) {
      return (
        <div>
          <div className='section' style={{maxWidth: '400px'}}>
            <p>
              You requested an immediate session with {this.props.expert.get('name')}.<br/>
              We're working to confirm {this.props.expert.get('name')}'s availability and will get back to you ASAP!<br/>
              Please leave this window open.
            </p>
          </div>
          <div className='section' style={{maxWidth: '400px', marginTop: 40}}>
            <Spinner type='three-bounce'/>
          </div>
        </div>
      )
    }
    else if (status === SESSION_REQUEST_STATUSES.TIMEDOUT) {
      return (
        <div>
          <div className='section' style={{maxWidth: '400px'}}>
            <p>
              Expert hasn't responded to your session request.<br/>
              You can book your session for later or cancel this request.
            </p>
          </div>
          <div className='section' style={{maxWidth: '400px', marginTop: 40, textAlign: 'center'}}>
            <a href='#' className='button success' onClick={this.props.onBookLaterClick}>Book for later</a>
          </div>
        </div>
      )
    }
    else if (status === SESSION_REQUEST_STATUSES.ACCEPTED) {
      return (
        <div>
          <div className='section' style={{maxWidth: '400px'}}>
            <p>
              {this.props.expert.get('name')} accepted your session request.<br/>
            </p>
          </div>
        </div>
      )
    }
    else if (status === SESSION_REQUEST_STATUSES.DISMISSED) {
      return (
        <div>
          <div className='section' style={{maxWidth: '400px'}}>
            <p>
              {this.props.expert.get('name')} didn't accept your session request.<br/>
            </p>
          </div>
          <div className='section' style={{maxWidth: '400px', marginTop: 40, textAlign: 'center'}}>
            <a href='#' className='button success' onClick={this.props.onBookLaterClick}>Book for later</a>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div className='book-session'>
        {this.renderInnerContent()}
      </div>
    )
  }
}

SessionBookConfirmationImmediate.defaultProps = {
  onSessionRequestAccepted: () => {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionRequest: state.getIn(['sessions', '_requests', ownProps.expert.get('uid'), ownProps.currentUser.get('uid')]),
    sessionRequestTimeout: state.getIn(['chatSettings', 'sessionRequestTimeout'])
  }
}

const mapDispatchToProps = () => {
  return {
    onLoadComponent: watchImmediateSessionRequest,
    onUnloadComponent: unwatchImmediateSessionRequest,
    onSessionRequestTimeout: timeoutSessionRequest
  }
}

const SessionBookConfirmationImmediateContainer = connect(
  mapStateToProps, mapDispatchToProps
)(SessionBookConfirmationImmediate)

export default SessionBookConfirmationImmediateContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/session_book_confirmation_immediate.js
 **/